"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VTOController = void 0;
const plattar_api_1 = require("@plattar/plattar-api");
const plattar_services_1 = require("@plattar/plattar-services");
const __1 = require("../..");
const raw_ar_1 = require("../../ar/raw-ar");
const util_1 = require("../../util/util");
const plattar_controller_1 = require("./plattar-controller");
/**
 * Manages an instance of the <plattar-configurator> HTML Element
 */
class VTOController extends plattar_controller_1.PlattarController {
    constructor(parent) {
        super(parent);
    }
    onAttributesUpdated() {
        const state = this._state;
        // re-render the QR Code when attributes have changed
        if (state === plattar_controller_1.ControllerState.QRCode) {
            this.startQRCode(this._prevQROpt);
            return;
        }
    }
    startViewerQRCode(options) {
        return new Promise((accept, reject) => {
            // remove the old renderer instance if any
            this.removeRenderer();
            const sceneID = this.getAttribute("scene-id");
            if (sceneID) {
                const opt = options || this._GetDefaultQROptions();
                const viewer = document.createElement("plattar-qrcode");
                // required attributes with defaults for plattar-viewer node
                const width = this.getAttribute("width") || "500px";
                const height = this.getAttribute("height") || "500px";
                viewer.setAttribute("width", width);
                viewer.setAttribute("height", height);
                if (opt.color) {
                    viewer.setAttribute("color", opt.color);
                }
                if (opt.margin) {
                    viewer.setAttribute("margin", "" + opt.margin);
                }
                if (opt.qrType) {
                    viewer.setAttribute("qr-type", opt.qrType);
                }
                viewer.setAttribute("shorten", (opt.shorten && (opt.shorten === true || opt.shorten === "true")) ? "true" : "false");
                let dst = plattar_api_1.Server.location().base + "renderer/facear.html?scene_id=" + sceneID;
                // optional attributes
                const configState = this.getAttribute("config-state");
                const showAR = this.getAttribute("show-ar");
                const productID = this.getAttribute("product-id");
                const sceneProductID = this.getAttribute("scene-product-id");
                const variationID = this.getAttribute("variation-id");
                if (configState) {
                    dst += "&config_state=" + configState;
                }
                if (showAR) {
                    dst += "&show_ar=" + showAR;
                }
                if (productID) {
                    dst += "&product_id=" + productID;
                }
                if (sceneProductID) {
                    dst += "&scene_product_id=" + sceneProductID;
                }
                if (variationID) {
                    dst += "&variation_id=" + variationID;
                }
                viewer.setAttribute("url", opt.url || dst);
                viewer.onload = () => {
                    return accept(viewer);
                };
                this.append(viewer);
                this._element = viewer;
                this._state = plattar_controller_1.ControllerState.QRCode;
                this._prevQROpt = opt;
                return;
            }
            return reject(new Error("VTOController.startQRCode() - minimum required attributes not set, use scene-id as a minimum"));
        });
    }
    startRenderer() {
        return new Promise((accept, reject) => {
            // remove the old renderer instance if any
            this.removeRenderer();
            const sceneID = this.getAttribute("scene-id");
            if (sceneID) {
                // required attributes with defaults for plattar-facear node
                const width = this.getAttribute("width") || "500px";
                const height = this.getAttribute("height") || "500px";
                const server = this.getAttribute("server") || "production";
                const viewer = document.createElement("plattar-facear");
                viewer.setAttribute("width", width);
                viewer.setAttribute("height", height);
                viewer.setAttribute("server", server);
                viewer.setAttribute("scene-id", sceneID);
                // optional attributes
                const configState = this.getAttribute("config-state");
                const showAR = this.getAttribute("show-ar");
                const productID = this.getAttribute("product-id");
                const sceneProductID = this.getAttribute("scene-product-id");
                const variationID = this.getAttribute("variation-id");
                if (configState) {
                    viewer.setAttribute("config-state", configState);
                }
                if (showAR) {
                    viewer.setAttribute("show-ar", showAR);
                }
                if (productID) {
                    viewer.setAttribute("product-id", productID);
                }
                if (sceneProductID) {
                    viewer.setAttribute("scene-product-id", sceneProductID);
                }
                if (variationID) {
                    viewer.setAttribute("variation-id", variationID);
                }
                viewer.onload = () => {
                    return accept(viewer);
                };
                this.append(viewer);
                this._element = viewer;
                this._state = plattar_controller_1.ControllerState.Renderer;
                return;
            }
            return reject(new Error("VTOController.startRenderer() - minimum required attributes not set, use scene-id as a minimum"));
        });
    }
    initAR() {
        return new Promise((accept, reject) => {
            if (!util_1.Util.canAugment()) {
                return reject(new Error("VTOController.initAR() - cannot proceed as VTO AR not available in context"));
            }
            if (!(util_1.Util.isSafari() || util_1.Util.isChromeOnIOS())) {
                return reject(new Error("VTOController.initAR() - cannot proceed as VTO AR only available on IOS Mobile devices"));
            }
            const arMode = this.getAttribute("ar-mode") || "generated";
            switch (arMode.toLowerCase()) {
                case "inherited":
                    this._InitARInherited(accept, reject);
                    return;
                case "generated":
                default:
                    this._InitARGenerated(accept, reject);
            }
        });
    }
    /**
     * Private Function - This launches the Static/Inherited AR Mode
     */
    _InitARInherited(accept, reject) {
        const sceneID = this.getAttribute("scene-id");
        const configState = this.getAttribute("config-state");
        // use config-state if its available
        if (sceneID && configState) {
            const state = __1.ConfiguratorState.decode(configState);
            const first = state.first();
            if (first) {
                const sceneProductAR = new __1.SceneProductAR(first.scene_product_id, first.product_variation_id);
                sceneProductAR.init().then(accept).catch(reject);
                return;
            }
            return reject(new Error("VTOController.initAR() - invalid config-state does not have any product states"));
        }
        // otherwise fallback to using scene
        if (sceneID) {
            __1.ConfiguratorState.decodeScene(sceneID).then((state) => {
                const first = state.first();
                if (first) {
                    const sceneProductAR = new __1.SceneProductAR(first.scene_product_id, first.product_variation_id);
                    return sceneProductAR.init().then(accept).catch(reject);
                }
                return reject(new Error("VTOController.initAR() - invalid Scene does not have any product states"));
            }).catch(reject);
            return;
        }
        return reject(new Error("VTOController.initAR() - minimum required attributes not set, use scene-id as a minimum"));
    }
    /**
     * Private Function - This launches the Dynamic/Generated AR Mode
     */
    _InitARGenerated(accept, reject) {
        // if scene ID is available and the state is a configurator viewer
        // we can use the real-time configurator state to launch the AR view
        const viewer = this.element;
        const sceneID = this.getAttribute("scene-id");
        if (viewer && sceneID && viewer.messenger) {
            viewer.messenger.getARFile("vto").then((result) => {
                const rawAR = new raw_ar_1.RawAR(result.filename);
                return rawAR.init().then(accept).catch(reject);
            }).catch(reject);
            return;
        }
        const configState = this.getAttribute("config-state");
        // otherwise scene ID is available to the viewer is not launched
        // we can use the static configuration state to launch the AR view
        if (sceneID && configState) {
            const state = __1.ConfiguratorState.decode(configState);
            if (state.length > 0) {
                const server = this.getAttribute("server") || "production";
                const configurator = new plattar_services_1.Configurator();
                configurator.server = server;
                configurator.output = "vto";
                state.forEach((productState) => {
                    if (productState.meta_data.augment === true) {
                        configurator.addSceneProduct(productState.scene_product_id, productState.product_variation_id);
                    }
                });
                configurator.get().then((result) => {
                    const rawAR = new raw_ar_1.RawAR(result.filename);
                    rawAR.init().then(accept).catch(reject);
                }).catch(reject);
                return;
            }
            return reject(new Error("VTOController.initAR() - invalid config-state does not have any product states"));
        }
        // otherwise no config-state or viewer is active
        // fallback to using default SceneAR implementation
        if (sceneID) {
            const productID = this.getAttribute("product-id");
            const sceneProductID = this.getAttribute("scene-product-id");
            const variationID = this.getAttribute("variation-id");
            const sceneAR = new __1.SceneAR(sceneID, {
                productID: productID ? productID : undefined,
                sceneProductID: sceneProductID ? sceneProductID : undefined,
                variationID: variationID ? variationID : undefined
            });
            sceneAR.init().then(accept).catch(reject);
            return;
        }
        return reject(new Error("VTOController.initAR() - minimum required attributes not set, use scene-id as a minimum"));
    }
    removeRenderer() {
        if (this._element) {
            this._element.remove();
            this._element = null;
            return true;
        }
        return false;
    }
    get element() {
        return this._element;
    }
}
exports.VTOController = VTOController;
